import { render, staticRenderFns } from "./EmailListing.vue?vue&type=template&id=66057042&scoped=true&"
import script from "./EmailListing.vue?vue&type=script&lang=js&"
export * from "./EmailListing.vue?vue&type=script&lang=js&"
import style0 from "./EmailListing.vue?vue&type=style&index=0&id=66057042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66057042",
  null
  
)

export default component.exports